
import Vue, { PropType } from 'vue';
import AnswerModel from './answer-model';
import { MultipleChoicePoll } from '../polls.controller';

export default Vue.extend({
    name: 'Answer',

    props: {
        poll: {
            type: Object as PropType<MultipleChoicePoll>,
            default: () => ({} as MultipleChoicePoll)
        },

        answer: {
            type: Object as PropType<AnswerModel>,
            default: () => ({} as AnswerModel)
        },

        resultsColor: {
            type: String,
            default: () => ''
        },
    },

    computed: {
        cssOverrides(): Record<string, unknown> {
            if (this.correct || !this.resultsColor) {
                return {
                    'width': this.answer.votePercentage,
                };
            }
            return {
                'width': this.answer.votePercentage,
                'background-color': this.resultsColor,
                'opacity': 0.3
            };
        },

        correct(): boolean {
            return this.showResults && this.answer.correct;
        },

        showResults(): boolean {
            return this.poll.show_results;
        },

        answerClasses(): Record<string, boolean> {
            return {
                'smvp-selected-correct': this.correct
            };
        }
    }
});
